import src from "IMAGE";
export default { src, width: 1675, height: 592, blurWidth: 0, blurHeight: 0};
